/** @module csi/table/QueryMoreController */
define([
	"dojo/_base/declare",
	"csi/_base/Deferred",
	"csi/view/QueryMoreController"
], function(declare,Deferred,QueryMoreController) {

	return declare(QueryMoreController, {
		progressTopic: "/csi/table/expand",
		
		/**
		 * @override
		 * Disable actions to protect against user clicking action twice while view is still loading
		 */
		process: function() {
			var view = this.widget;
			var qr = view.getQueryResultByDomNode(this.m_element);
			
			// if querying more, then increase the display count target
			if (qr.parentResult.isRoot() && view.incrementalQuerySize) {
				view.set("queryDisplayCountTarget", view.queryDisplayCountTarget + view.querySize);
			}

			// save table scrolling position
			view.saveScrollPosition();

			if (view.getAutoExpandLevel()) {
				this.displayProgressDialog({
					closable: false,
					progressValue: 0
				});
			}
			
		    this.disableActionView(true);
			this.when(this._widgetQueryMore(this.m_element), () => this.postProcess(true));
		},

		/**
		 * @override
		 * Restore table scroll position
		 */
		postProcess: function(bStatus, bRepeat) {
			this.widget.restoreScrollPosition();
			this.inherited(arguments);
		},
		
		/**
		 * Call widget's queryMore function
		 * This function can be overridden, and used in QueryViewAllController
		 * @param {DOMNode} domNode
		 * @return {Deferred}
		 */
		_widgetQueryMore: function(domNode){
			return this.widget.queryMore(domNode);
		}
	});
});